import { useRouter } from 'next/router';

interface PromotionQuery {
  /** 기획전 id */
  id?: string;
  /** 앵커링할 id */
  anchor?: string;
  /** 외부에서 진입시 초기 앵커링 여부 */
  // eslint-disable-next-line camelcase
  anchor_section?: string;
  /** section 정보 */
  section?: string;
}

interface UsePromotionQueryParam {
  isProd: boolean;
  defaultId?: number;
}

interface UsePromotionQueryResponse {
  promotionId: number;
  anchorTargetId?: string;
  anchorSection?: string;
  section: string;
}

export function usePromotionQuery({
  isProd,
  defaultId,
}: UsePromotionQueryParam): UsePromotionQueryResponse {
  const router = useRouter();
  const {
    id,
    section,
    anchor: anchorTargetId,
    anchor_section: anchorSection,
  } = router.query as PromotionQuery;

  const promotionId = isProd && defaultId ? defaultId : (id ?? defaultId);

  const numericPromotionId = Number(promotionId);
  const validPromotionId =
    !isNaN(numericPromotionId) && numericPromotionId > 0
      ? numericPromotionId
      : (defaultId ?? 0);

  return {
    promotionId: validPromotionId,
    anchorTargetId,
    anchorSection,
    section: section ?? '',
  };
}
